// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"c5f01b2c87d8e8716dd7","OlapicWidget":"26d014b1ee86a4f06d03"}[chunkId] + ".bundle.js";
};